import { OPENED_DELIVERY_ITEM_BACKGROUND_URL } from '../../../assets/deliveryDialogAssets';
import './OpenedDeliveryItemBackground.css';

export function OpenedDeliveryItemBackground() {
  return (
    <img
      className="success-delivery-opened-item"
      src={OPENED_DELIVERY_ITEM_BACKGROUND_URL}
      alt=""
      draggable={false}
    />
  );
}
